import { Icon } from "@circle-react/components/shared/Icon";
import type { MouseEventHandler } from "react";

import { t } from "@/i18n-js/instance";

interface CloseButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button
    type="button"
    className="bg-secondary border-primary text-dark absolute -right-2.5 -top-2.5 z-[1] flex scale-50 cursor-pointer items-center justify-center rounded-full border opacity-0 transition-all duration-200 group-hover:scale-100 group-hover:opacity-100"
    onClick={onClick}
    aria-label={t("close")}
  >
    <Icon type="close" />
  </button>
);
